import { createElement, lazy } from 'react';
import type { FeatureModule } from '@/app/contract';
import { APP_ROUTES, communityPath, communitySearchPath } from '@/app/paths';
import { registerFeatureRuntime } from '@/app/runtimes';
import { registerNamespace } from '@/i18n';
import { registerPartRenderer } from '@/features/chat/registry';
import { SharedPost, PublishRequestPart } from './parts/PostParts';
import { isAvailable } from './availability';
import en from './locales/en.json';
import zh from './locales/zh-Hans.json';
import './discover.css';
import { compose } from './modals';
import { DiscoverIcon } from './components/DiscoverIcon';
import { DiscoverCleanupRuntime } from './data/Startup';
registerFeatureRuntime('discover.cleanup', DiscoverCleanupRuntime, { phase: 'services' });
registerNamespace('discover', { en, 'zh-Hans': zh });
registerPartRenderer('post', SharedPost);
registerPartRenderer('post_publish_request', PublishRequestPart);
const pages = {
  discover: lazy(() => import('./pages/DiscoverPage')),
  post: lazy(() => import('./pages/PostPage')),
  postReplies: lazy(() => import('./pages/PostPage')),
  topic: lazy(() => import('./pages/TopicPage')),
  communityAuthor: lazy(() => import('./pages/ProfilePage')),
  myPosts: lazy(() => import('./pages/MyPostsPage')),
  communityDrafts: lazy(() => import('./pages/DraftsPage')),
  communitySaved: lazy(() => import('./pages/SavedPage')),
  communitySavedFolder: lazy(() => import('./pages/SavedPage')),
  communitySearch: lazy(() => import('./pages/SearchPage')),
  communityActivity: lazy(() => import('./pages/ActivityPage')),
  communityManage: lazy(() => import('./pages/ManagePage')),
  publishRequest: lazy(() => import('./pages/PublishRequestPage')),
};
const feature: FeatureModule = {
  id: 'discover', section: { id: 'discover', titleKey: 'discover:title', icon: DiscoverIcon, isAvailable },
  commands: [
    { id: 'discover.search', titleKey: 'discover:commands.search', run: nav => nav.open(communitySearchPath(nav.section)) },
    { id: 'discover.compose', titleKey: 'discover:commands.newPost', run: nav => compose(nav) },
    { id: 'discover.saved', titleKey: 'discover:savedTitle', run: nav => nav.open(communityPath(nav.section, 'saved')) },
  ],
  routes: (Object.keys(pages) as (keyof typeof pages)[]).map(name => ({ ...APP_ROUTES[name], component: () => createElement(pages[name]) })),
};
export default feature;
